'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav
        id="main-nav"
        className={`fixed top-0 left-0 w-full z-[100] px-4 md:px-6 transition-all duration-500 ${
          scrolled ? 'py-3' : 'py-5'
        }`}
      >
        <div className="max-w-6xl mx-auto flex items-center justify-between glass rounded-2xl px-5 md:px-8 py-3 transition-all duration-500">
          <Link href="/homepage" className="flex items-center gap-2 group">
            <div className="flex items-center">
              <img
                alt="Logo"
                width={36}
                height={36}
                className="flex-shrink-0"
                src="https://homeify-o47ru61.public.builtwithrocket.new/_next/image?url=%2Fassets%2Fimages%2Fapp_logo.png&w=96&q=85"
              />
            </div>
            <span className="font-sans font-extrabold text-lg tracking-tight text-ink hidden sm:block">
              Homeify<span className="font-serif italic font-normal text-ink-muted">Services</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link href="/homepage#services" className="text-[13px] font-semibold text-ink-muted hover:text-ink transition-colors duration-200 tracking-wide">Services</Link>
            <Link href="/homepage#why" className="text-[13px] font-semibold text-ink-muted hover:text-ink transition-colors duration-200 tracking-wide">Why Homeify</Link>
            <Link href="/homepage#process" className="text-[13px] font-semibold text-ink-muted hover:text-ink transition-colors duration-200 tracking-wide">How It Works</Link>
          </div>

          <div className="flex items-center gap-3">
            <Link
              href="/homepage#services"
              className="hidden md:inline-flex items-center justify-center bg-ink text-paper px-5 py-2 rounded-full text-[13px] font-bold hover:bg-ink-soft transition-all duration-300 hover:scale-105 active:scale-95"
            >
              Services
            </Link>
            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-ink"
              aria-label="Open menu"
              onClick={() => setMenuOpen(true)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width={22} height={22}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <button
          className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-white"
          aria-label="Close menu"
          onClick={() => setMenuOpen(false)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width={24} height={24} className="text-white">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
        <div className="flex items-center gap-2 mb-8">
          <div className="flex items-center">
            <img
              alt="Logo"
              width={40}
              height={40}
              className="flex-shrink-0"
              src="https://homeify-o47ru61.public.builtwithrocket.new/_next/image?url=%2Fassets%2Fimages%2Fapp_logo.png&w=96&q=85"
            />
          </div>
          <span className="font-sans font-bold text-xl text-white">
            Homeify<span className="font-serif italic font-normal text-white/60">Services</span>
          </span>
        </div>
        <Link href="/homepage#services" className="text-2xl font-bold text-white/80 hover:text-white transition-colors" onClick={() => setMenuOpen(false)}>Services</Link>
        <Link href="/homepage#why" className="text-2xl font-bold text-white/80 hover:text-white transition-colors" onClick={() => setMenuOpen(false)}>Why Homeify</Link>
        <Link href="/homepage#process" className="text-2xl font-bold text-white/80 hover:text-white transition-colors" onClick={() => setMenuOpen(false)}>How It Works</Link>
      </div>
    </>
  );
}
